import { useCallback, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";

const scrollToHash = (hash) => {
  const el = document.querySelector(hash);
  if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
};

/**
 * Returns a navigator that handles both in-page anchors ("#book") and routes ("/services").
 * Anchors on other pages are resolved by navigating home with the hash, then scrolling.
 */
export function useGoTo() {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  return useCallback(
    (href) => {
      if (href.startsWith("#")) {
        if (pathname === "/") scrollToHash(href);
        else navigate(`/${href}`);
        return;
      }
      navigate(href);
    },
    [navigate, pathname],
  );
}

/** Scrolls to the URL hash after a route change, or to top when there is none. */
export function useHashScroll() {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) {
      const t = setTimeout(() => scrollToHash(hash), 80);
      return () => clearTimeout(t);
    }
    window.scrollTo({ top: 0, behavior: "auto" });
  }, [pathname, hash]);
}
